/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Alerts_Types_Proximity_LabelInputs */

const es_billing_alerts_types_proximity_label = /** @type {(inputs: Billing_Alerts_Types_Proximity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviso por proximidad`)
};

const en_billing_alerts_types_proximity_label = /** @type {(inputs: Billing_Alerts_Types_Proximity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proximity alert`)
};

/**
* | output |
* | --- |
* | "Proximity alert" |
*
* @param {Billing_Alerts_Types_Proximity_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_alerts_types_proximity_label = /** @type {((inputs?: Billing_Alerts_Types_Proximity_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Alerts_Types_Proximity_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_alerts_types_proximity_label(inputs)
	return en_billing_alerts_types_proximity_label(inputs)
});
export { billing_alerts_types_proximity_label as "billing.alerts.types.proximity.label" }